Vue.component('ack-mobile-navbar-item', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-mobile-navbar-item',

	props: {
		menuItemObject: {
			type: Object,
		},
	},
	computed: {
		...Vuex.mapGetters('navBar', ['switchMobileDropdowns']),
		...Vuex.mapGetters('localization', ['countryCode', 'isUS_CA']),
		storeAvailable() {
			return this.$parent.storeAvailable;
		},
	},
	data() {
		return {
			menuOpen: false,
			isVisible: true,
			lastScrollTop: 0,
			menuOpening: false,
			menuItemsWithAvailability: [],
		};
	},
	methods: {
		...Vuex.mapActions('navBar', ['sayHi', 'closeAllMobileDropdowns']),

		toggleMenu() {
			if (this.menuOpen === false) {
				this.menuOpening = true;
				this.closeAllMobileDropdowns();
				this.$emit('on-open-menu');
			} else {
				this.menuOpen = false;
			}
			//this.menuOpen = !this.menuOpen
		},
	},
	beforeDestroy() {},
	watch: {
		switchMobileDropdowns: {
			handler() {
				if (this.switchMobileDropdowns === false) {
					if (this.menuOpening === true) {
						this.menuOpen = true;
						this.menuOpening = false;
					} else {
						this.menuOpen = false;
					}
				}
			},
			deep: false,
		},
		menuItemObject: {
			handler(newVal) {
				this.menuItemsWithAvailability = newVal.items.filter((item) => {
					if (item.hidden) return false;

					if (item.onlyIfStoreAvailable === true) {
						item.isAvailable = this.storeAvailable;
					} else {
						item.isAvailable = true;
					}

					if (item.isAvailable && item.hideItemInCountries) {
						const country = item.hideItemInCountries.find(
							(m) => m.toUpperCase() === this.countryCode.toUpperCase(),
						);
						if (country) {
							item.isAvailable = false;
						}
					}

					return item.isAvailable;
				});
			},
			deep: true,
			immediate: true,
		},
	},
});
